import { useCallback, useEffect, useState } from 'react';
import { startHomeLoad } from './homeLoadTiming';
import { withTimeout, LoadTimeoutError } from './loading';

export function useTimedLoad<T>(load: () => Promise<T>, label = 'detail', enabled = true) {
    const [attempt, setAttempt] = useState(0);
    const [state, setState] = useState<{ source?: typeof load; data?: T; loading: boolean; error: boolean }>({ loading: true, error: false });
    const retry = useCallback(() => setAttempt(value => value + 1), []);
    useEffect(() => {
        if (!enabled) return;
        let active = true;
        const timing = startHomeLoad(label, attempt);
        setState({ source: load, loading: true, error: false });
        withTimeout(Promise.resolve().then(load)).then(data => {
            if (active) {
                timing.finish('complete', Array.isArray(data) ? data.length : 1);
                setState({ source: load, data, loading: false, error: false });
            }
        }, error => {
            if (active) {
                timing.finish(error instanceof LoadTimeoutError ? 'timeout' : 'error');
                setState({ source: load, loading: false, error: true });
            }
        });
        return () => { active = false; timing.finish('cancelled'); };
    }, [load, label, attempt, enabled]);
    if (!enabled) return { data: undefined, loading: false, error: false, retry };
    return state.source === load ? { ...state, retry } : { data: undefined, loading: true, error: false, retry };
}
